var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustomPolicy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D5DD",
  d: "M20.689 7.374H2.899a.9.9 0 0 0-.9.9v1.485a.9.9 0 0 0 .9.9h17.79a.9.9 0 0 0 .9-.9V8.274a.9.9 0 0 0-.9-.9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#A2A7B3",
  d: "M19.931 10.656H3.658v7.674H19.93v-7.674Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D5DD",
  d: "M20.689 18.332H2.899a.9.9 0 0 0-.9.9v1.486a.9.9 0 0 0 .9.9h17.79a.9.9 0 0 0 .9-.9v-1.486a.9.9 0 0 0-.9-.9M12.35.302H11v4.5h1.35z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A59E",
  d: "M14.6.302H11v2.25h3.6a.9.9 0 0 0 .9-.9v-.45a.9.9 0 0 0-.9-.9"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#6E7481",
  d: "M10.169 18.335v-4.719a1.678 1.678 0 0 0-3.356 0v4.719zm6.609 0v-4.719a1.678 1.678 0 0 0-3.356 0v4.719z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#56CEC2",
  d: "M11.609 3.132c-2.91 0-5.418 1.739-6.56 4.243h13.12c-1.143-2.504-3.65-4.243-6.56-4.243"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18.525,
  cy: 19.325,
  r: 2.025,
  fill: "#D9D9D9"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#535861",
  d: "M22.35 19.998a.9.9 0 0 0 .9-.9v-.035a.9.9 0 0 0-.9-.9h-.564a3 3 0 0 0-.246-.582l.391-.391a.9.9 0 0 0 0-1.273l-.025-.025a.9.9 0 0 0-1.272 0l-.4.4a3 3 0 0 0-.585-.24V15.5a.9.9 0 0 0-.9-.9h-.035a.9.9 0 0 0-.9.9v.565a3 3 0 0 0-.582.245l-.391-.39a.9.9 0 0 0-1.273 0l-.025.024a.9.9 0 0 0 0 1.273l.4.4q-.149.277-.24.584h-.553a.9.9 0 0 0-.9.9v.035a.9.9 0 0 0 .9.9h.565q.094.306.245.583l-.39.39a.9.9 0 0 0 0 1.274l.024.024a.9.9 0 0 0 1.273 0l.4-.399q.277.147.584.239v.553a.9.9 0 0 0 .9.9h.035a.9.9 0 0 0 .9-.9v-.564q.306-.095.583-.246l.39.391a.9.9 0 0 0 1.274 0l.024-.025a.9.9 0 0 0 0-1.272l-.399-.4q.147-.277.239-.585h.553Zm-5.115-.899a1.515 1.515 0 1 1 3.031 0 1.515 1.515 0 0 1-3.03 0Z"
})));
export default SvgCustomPolicy;